module.exports = __webpack_public_path__ + "img/肌如初雪套装_04.eb73e022.jpg";